import loadable from '@loadable/component'
import LoaderBox from './LoaderBox'

export function FullLoader(loadFn) {
  return loadable(loadFn, {
    fallback: <LoaderBox loader />
  })
}
